import {preconnect, prefetchDNS} from 'react-dom';

import {getConfig} from 'coreUtils/utils';

/**
 * Early connections from the server `<head>` (`app.resourceHints` of the config): `preconnect` to the origins of the
 * images of the first paint (CMS assets), `prefetchDNS` to the ones of scripts loaded later (GTM).
 */
const ResourceHints = () => {
	const {preconnect: preconnectOrigins = [], prefetchDNS: dnsOrigins = []} = getConfig().app.resourceHints || {};

	// No `crossOrigin`: images are no-cors requests, a CORS connection would not be reused for them.
	preconnectOrigins.forEach((origin: string) => preconnect(origin));
	dnsOrigins.forEach((origin: string) => prefetchDNS(origin));

	return null;
};

export default ResourceHints;
